import qwToolsLayout from "@/views/qwTools/index.vue";
export const qwToolsRouter = [
  {
    path: "/qwTools",
    name: "qwTools",
    component: qwToolsLayout,
    hidden: true,
    children: [
      {
        path: "/qwTools/center",
        component: () => import("@/views/qwTools/center"),
        name: "qwToolsCenter",
      },
      { // 自动跳转页，带参数登录后会自动转发
        path: "/qwTools/autoLoginRedirect",
        component: () => import("@/views/qwTools/autoLoginRedirect.vue"),
        name: "qwToolsAutoLoginRedirect",
      },
      {
        path: "/qwTools/scriptLibrary",
        component: () => import("@/views/qwTools/scriptLibrary"),
        name: "qwToolsScriptLibrary",
      },
      {
        path: "/qwTools/materialLibrary",
        component: () => import("@/views/qwTools/materialLibrary"),
        name: "qwToolsMaterialLibrary",
      },
      {
        path: "/qwTools/materialLibraryOrientation",
        component: () => import("@/views/qwTools/materialLibraryOrientation"),
        name: "qwToolsMaterialLibraryOrientation",
      },
      {
        path: "/qwTools/task",
        component: () => import("@/views/qwTools/task/index"),
        name: "qwToolsTask",
      },
      {
        path: "/qwTools/task/auth",
        component: () => import("@/views/qwTools/task/auth"),
        name: "qwToolsTaskAuth",
      },
      {
        path: "/qwTools/finance/index",
        component: () => import("@/views/qwTools/finance/index"),
        name: "qwToolsFinanceIndex",
      },
      {
        path: "/qwTools/messageDeal/index",
        component: () => import("@/views/qwTools/messageDeal/index"),
        name: "qwToolsMessageDealIndex",
      },
    ],
  },
];
